"use strict";

require("../../style/index.less");

require("../../grid/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/row/style/index.js
// module id = 25
// module chunks = 1